export default [
    "Mr.",
    "Mrs.",
    "Miss",
    "Dr.",
    "Ms.",
    "Prof."
]